module.exports = __webpack_public_path__ + "media/images/advert-img-02-eb8c3eccb73453fd9c48013a58371d4a.png";